import type { FaireProductEntity } from "../../entity_types/product";

export const p_j43fre32cm: FaireProductEntity = {
  token: "p_j43fre32cm",
  type: "product",
  name: "Harper Long Open Front Cardigan",
  brandToken: "b_aikxxfpecb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7c947a16df4d8b0ea80887fc3c910d8474f8a0850d27a1a8e45fa17290ef8b1c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/22be58dc092d4d77808f5869b06ab80090afa83c1fbcf1f32cb237d01d15507c.jpeg",
    "https://cdn.faire.com/fastly/dc0fcf25fb30a2bcec9fc6acf7f7654556dc1f7d602663ca954c304b7b0e30cd.jpeg",
    "https://cdn.faire.com/fastly/7d59447f393a16de4e5e6ab73f87b9bd48c15ff53ceb21f2ab69ea8c8893309d.jpeg",
    "https://cdn.faire.com/fastly/b7c0822f1a0c9278256cd71e4f412a2e1794622fab67fc71db3bcd35e96885b9.jpeg",
    "https://cdn.faire.com/fastly/f998ddbebe809d595fa96d31d7160996d5e6b565afd5baefb0fd5e36b02d123f.jpeg",
    "https://cdn.faire.com/fastly/9263ba0c4506c3ab89e3af079525cda2ff94646df55c461569dd391e53132c3f.jpeg",
    "https://cdn.faire.com/fastly/224084be87eec262501e9131a4df36b1becb820d3b58cc481083713d33875b4f.jpeg",
    "https://cdn.faire.com/fastly/03f4c658a1f98e5b30d0b81b04f1df79a33bebc947e2da11ab57f51e17ad4bf2.jpeg",
    "https://cdn.faire.com/fastly/9b06503a63153ac0e12590e9d7fb29ef6bad5e75ad88b2f24c60189d2e2b33dc.jpeg",
    "https://cdn.faire.com/fastly/f8be2c1c69a952a5bbc24fdc02fcf5e7eb600ac447252da1a567eebbdb035420.png",
  ],
  priceDollars: 37,
  description:
    "Meet Harper Long Open Front Cardigan—effortless, flattering, and easy to style for everyday life. This plaid cardigan provides you with a classic and casual look The loose fit and long length design make it suitable for all shape The knit fabric ensures you stay comfy no matter what you're doing Great for casual, daily, vacation, office, home, school, church, and outdoors Women's cardigans are suitable for spring, fall, and winter\n\nMaterial: 65%Acrylic+35%Polyester.\n",
  tags: [],
  msrpDollars: 74,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:52.067Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
